import * as yup from 'yup'

const DOCUSIGN_ID_FORMAT_MESSAGE =
  'DocuSign ID must be a valid template ID (a GUID, e.g. 0f1e2d3c-4b5a-6978-8796-a5b4c3d2e1f0).'

// Parity with the backend's `@IsUUID()` (no argument), which class-validator 0.15.1 resolves
// to validator.js's `all` pattern: versions 1-8, plus the nil and max GUIDs. Copied verbatim so
// the form never rejects a template ID the API would accept — the client check exists to give a
// readable message, not to be stricter. yup's own `.uuid()` allows only versions 1-5 and would
// reject a v6/v7/v8 DocuSign ID outright.
const DOCUSIGN_ID_PATTERN =
  /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i

export const docusignTemplateFormValidator = yup.object({
  title: yup.string().trim().required('Title is required'),
  docusignId: yup
    .string()
    // `.trim()` runs before `.matches()` on purpose: the most common bad input is a GUID pasted
    // with surrounding whitespace, which would otherwise be rejected as malformed.
    .trim()
    .required('DocuSign ID is required')
    // The backend validates this with `@IsUUID` and rejects anything else with a message that
    // names the DTO property rather than the problem — see the design's §2.3.
    .matches(DOCUSIGN_ID_PATTERN, DOCUSIGN_ID_FORMAT_MESSAGE),
  // Optional, matching `@IsOptional @IsString` on GigSafeAdminCreateDocusignTemplateDTO.
  description: yup.string().trim(),
})
